<template>
  <div v-if="is_quality_control && quality_control_view === 'value'" class="qc-filter-panel" >
    <div v-if="quality_control_view === 'value'" style="font-size: 30px;">
      {{ getDeepValue(openedEvent, quality_control_event_key) }}
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

function getDeepValue(obj, path) {
  if (!obj || !path) return undefined;
  return path.split('.').reduce((o, key) => (o && o[key] !== undefined ? o[key] : undefined), obj);
}

export default {
  name: 'QualityPanelFilter',
  computed: {
    ...mapGetters('filter', [
      'quality_control_view',
      'quality_control_event_key',
      'quality_control_percentage_checked',
      'quality_control_analysis_phase',
      'openedEvent',
      'is_quality_control'
    ])
  },
  methods: {
    getDeepValue
  }
}
</script>

<style scoped>
.qc-filter-panel {
  background-color: #f0f0f0;
  padding: 10px;
  position: absolute;
  top: 0;
  left: 0;
  width: 200px;
  height: 100px;
  z-index: 1000;
}
</style>